import { type AbsoluteRoutePathWithId, isRelativeRoutePathWithId, type RelativeRoutePathWithId } from './Domain'
import { useHasCapabilities } from './Hook.HasCapabilities'
import { useInternalRoutingHook } from './Hook.InternalRouting'

export const useRedirectionWithId = <I>(
    route: AbsoluteRoutePathWithId | RelativeRoutePathWithId,
    idMapper: (input: I) => string
): ((input: I) => void) | void => {
    const hasCapabilities = useHasCapabilities()
    const router = useInternalRoutingHook()

    const absoluteRoute = isRelativeRoutePathWithId(route) ? router.getAbsoluteRoute(route) : route

    return hasCapabilities(absoluteRoute) ? (i: I) => router.redirect(absoluteRoute, idMapper(i)) : undefined
}
